module.exports = __webpack_public_path__ + "img/top-bg.3549bbab.png";